<vi-alert
  *ngIf="
    (remoteDiagnosticsStore.getParametersStartedOrSelected(gatewaySerial) | async)?.length >= 10
  "
  >{{ 'DIAGNOSTICS.PARAMETER_LIST.LIMIT_REACHED_WARNING' | translate }}</vi-alert
>
<div
  *ngIf="remoteDiagnosticsStore.getAvailableIntervals$ | async as availableIntervals"
  class="margin-bottom"
>
  <ng-container *ngFor="let parameter of selectedParameters; trackBy: parameterByIdTrackBy">
    <app-diagnostics-parameter-item
      [parameter]="parameter"
      [availableIntervals]="availableIntervals"
    ></app-diagnostics-parameter-item>
  </ng-container>
</div>
